import saraImage from '../assets/images/vet-profiles/sara-ochoa.png';
import callumImage from '../assets/images/vet-profiles/callum-turner.png';
import micheleImage from '../assets/images/vet-profiles/michele-king.png';
import vetPlaceholderImage from '../assets/images/vet-profiles/vet-placeholder.png';

export const data = [
  {
    name: 'Dr. Sara O',
    degree: 'DVM',
    specialization: 'I am a small and exotic animal vet. I have experience working with all types of animals. My interests are surgery, orthopedics and exotic animal medicine.',
    imageUrl: saraImage,
  },
  {
    name: 'Dr. Michele K',
    degree: 'DVM',
    specialization: 'I am a small animal veterinarian, specializing in medical problems of dogs and cats. I have a wealth of knowledge, having practiced in multiple types of venues over the last 20 years.',
    imageUrl: micheleImage,
  },
  {
    name: 'Dr. Jessica N',
    degree: 'DVM',
    specialization: 'Practicing for 8 years, with a focus on small animals. I enjoy preventative care, internal medicine, dentistry, and surgery.',
    imageUrl: vetPlaceholderImage,
  },
  {
    name: 'Dr. Callum T',
    degree: 'DVM',
    specialization: 'Specializing in small animals and exotics',
    imageUrl: callumImage,
  },
];
